/**
 * Field Component Registry
 *
 * Maps form element types to their corresponding React components.
 */

import { TextField } from '../components/TextField';
import { NumberField } from '../components/NumberField';
import { TextAreaField } from '../components/TextAreaField';
import { RadioField } from '../components/RadioField';
import { CheckboxField, SingleCheckbox } from '../components/CheckboxField';
import { DateField } from '../components/DateField';
import { YesNoField } from '../components/YesNoField';
import { QuestionnaireGrid } from '../components/QuestionnaireGrid';

/**
 * Default field component mapping
 */
const fieldComponentMap: Record<string, React.ComponentType<any>> = {
  'text': TextField,
  'number': NumberField,
  'textarea': TextAreaField,
  'radio': RadioField,
  'checkbox': CheckboxField,
  'single-checkbox': SingleCheckbox,
  'date': DateField,
  'yes-no': YesNoField,
  'questionnaire-grid': QuestionnaireGrid,
};

/**
 * Get field component for a given element type
 */
export function getFieldComponent(elementType: string): React.ComponentType<any> | null {
  return fieldComponentMap[elementType] || null;
}

/**
 * Register a custom field component
 */
export function registerFieldComponent(elementType: string, component: React.ComponentType<any>): void {
  fieldComponentMap[elementType] = component;
}

export default fieldComponentMap;
